import React from 'react';

const OrganizerIllustrationSvg = (props) => (
    <svg viewBox="0 0 232 320" {...props}>
        <style>
            {
                '.organizer-illustration_svg__st0{fill:#dbdae3}.organizer-illustration_svg__st1{fill:#1e0a3c}.organizer-illustration_svg__st2{fill:#c2c2cc}.organizer-illustration_svg__st3{fill:#fff}.organizer-illustration_svg__st4{fill:#f05537}.organizer-illustration_svg__st5{fill:#479980}.organizer-illustration_svg__st6{fill:#324b8c}'
            }
        </style>
        <path
            className="organizer-illustration_svg__st0"
            d="M108.8 257.4c-49.5 0-91.9 1.7-108.8 6.3v11.2c16.9 6.9 59.3 13.4 108.8 13.4 64.5 0 116.7-11.1 116.7-19.6.1-8.5-52.2-11.3-116.7-11.3z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M191.3 233.9l2.3 9 6.5-1.5s6.4 2.2 9.7 1.7c3.1-.5 8.5-1.3 8.5-1.3l-1.1-2.7-8.6-1.4-10.5-5.1-3.9-6.3"
        />
        <path
            className="organizer-illustration_svg__st2"
            d="M211 243.1l.9-4.8c4.7.9 5.9-.5 6.4 3.7"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M196.5 236l2.2-3.2.3.2-2.2 3.2-.3-.2zM199 236.8l2.1-2.9.3.2-2.1 2.9-.3-.2zM201.3 237.6l1.9-2.6.3.2-1.9 2.6-.3-.2zM203.7 238.3l1.7-2.3.3.2-1.7 2.3-.3-.2zM206.1 239.2l1.5-2.1.3.2-1.5 2.1-.3-.2z"
        />
        <path
            className="organizer-illustration_svg__st0"
            d="M66.5 31h86.4c4.1 0 7.4 3.3 7.4 7.4v98.7c0 4.1-3.3 7.4-7.4 7.4H66.5c-4.1 0-7.4-3.3-7.4-7.4V38.3c0-4.1 3.3-7.3 7.4-7.3z"
        />
        <path
            className="organizer-illustration_svg__st0"
            d="M.1 134.1h69.1c4.1 0 7.4 3.3 7.4 7.4v54.3c0 4.1-3.3 7.4-7.4 7.4H.1"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M38.4 179.5c0-3.6 0-7.5 2.4-10.2.6-.6 1.4-1.2 2.2-1.1.7.2 1.3.7 1.6 1.4 1.2 2.1 1.3 4.6 1.3 7l.3 20c0 3.3.1 6.7.2 10 0 2.2.2 6-1 7.9-.3.3-.5.7-.6 1.1-.1.5 0 1.1.3 1.6 2.2 5.5 1.7 11 1.8 16.9 0 1.3-6.9-2.1-7.5-4.2-.6 0-.5-9-.5-9.8 0-1.2 0-2.6.5-3.7.3-.5.7-1 .7-1.6 0-1-.9-2.1-1.1-3.1-.3-1.3 0-2.9-.1-4.3l-.2-9.5-.3-18.4z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M91 199.7c-9.2-6.5-59-96-56.9-115 3.1-28.1 31-13.1 47.3-9.6 22.3 4.7 29.7 3.7 66.1-9.2 17.4-6.2 57.1-12.1 41.7 37.8-6.1 19.9-25 58.9-34.1 80.2-10.2 24-52.8 23.7-64.1 15.8z"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M147.7 96.9c-4.8-3.2-19-5.3-19-5.3l-17.4-1s-20.1 3.1-23.9 7.3c-4.7 5.2-8.4 14-11.9 30.2-4.3 20.5-2.1 15.2 11.9 40.9 1.5 2.7 55.9 12.9 68.5 7.5 0 0-1.3-4.2 1.6-7.4 14.1.1-3.3-67.7-9.8-72.2z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M115.3 211.8h1.7v34.9h-1.7v-34.9z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M36.2 196.7c0-1.5-.2-4.8-1.6-6.1-.3-.3-.3-.7 0-1 .2-.3.4-.6.5-1 .6-1.6.1-3.7-.2-5.3-.1-.6-.4-1.2-.9-1.6-.5-.3-1.6-.3-2.1-.1-.5.2-1.1 1.6-1.2 1.9-.5 1.1-.6 2.3-.5 3.5.1 1.1.5 3 1.8 3.4-2 1.3-1.8 6.2-1.7 8.5.1 8.6.3 17.3.5 25.9.1 3.8-.8 9.2.3 12.9.5 1.6 5.8 4.2 5.8 3.3l-.7-44.3z"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M23.7 229.3h30.1V258c0 5.2-4.2 9.5-9.5 9.5H33.2c-5.2 0-9.5-4.2-9.5-9.5v-28.7z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M194.8 130.2l2.3-2.6.3.3-2.3 2.6-.3-.3zM192.8 129l.8-2.9.4.1-.8 2.9-.4-.1zM196.4 132l2.8-1.2.2.4-2.8 1.2-.2-.4z"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M139 80.5h-.3c-.9-.3-1-1.9-.3-3.6.7-1.7 1.8-2.8 2.7-2.5.9.3 1 1.9.3 3.6-.6 1.5-1.6 2.5-2.4 2.5zm0-3.5c-.6 1.5-.4 2.6 0 2.8.4.1 1.3-.6 1.9-2.1.6-1.5.4-2.6 0-2.8-.4-.1-1.3.6-1.9 2.1z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M128.7 91.7c-.6-1.7-.8-3.6-.3-5.3 0 0 5.2 2 6.3 1.1 1.1-1 2.6-5.3 2.6-5.3.8 0 1.6-.1 2.3-.2-.7-1.4-.1-4.2-.1-4.2s3.1-7.8 3.2-9c.2-2-2.6-14.1-15.5-12.5-12.4 1.8-11.5 14.6-10.7 19.3-.5 9.5-5.2 15.3-5.2 15.3s3.6 6.8 9.6 7.2c4.3 0 8-2.6 7.8-6.4z"
        />
        <circle
            className="organizer-illustration_svg__st1"
            cx={129.2}
            cy={49.5}
            r={4.4}
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M122.6 73.9s-2.5-5.3.3-5.9c2.4-.6 3.4 2.4 3.3 3.8 1.6-1 2.8-2.5 3.3-4.3 1.8.8 9.4 3.7 13.7 3.9 1.9-4.6-1.9-17-16.1-15.3-14.2 1.6-10.7 19.3-10.7 19.3l-.4 2.9 2.8-1.6 3.8-2.8z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M133.8 69.5l2.4-5.3-1.1 6.4"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M136.1 79.3h-.3c-.9-.3-1-1.9-.3-3.6.3-.7.7-1.4 1.2-1.9s1.1-.7 1.5-.5c.9.3 1 1.9.3 3.6-.6 1.4-1.5 2.4-2.4 2.4zm0-3.5c-.6 1.5-.4 2.6 0 2.8.4.1 1.3-.6 1.9-2.1s.4-2.6 0-2.8c-.2-.1-.5.1-.8.4-.5.6-.9 1.2-1.1 1.7z"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M128.3 72.9l.2-.6 7.4 2.9-.2.6-7.4-2.9z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M111.3 90.6l-1.3.2c2.1 8 8.8 13 8.8 13l4.7-5.7 6.5 3.5-1.3-10c.2 2.8-2.4 5.5-5.3 5.9-3.7.7-8.5-1-12.1-6.9zM89.9 177.5C83.6 98.4 87.6 57.2 64.1 57.6c-12.6.2-31.4 12.6-36.3 34.1-4.8 21.4 38 89.5 52 104.6 12.4 13.4 70.4 19 75.6-12.4-6.2 16.1-63.2 21.9-65.5-6.4z"
        />
        <path
            className="organizer-illustration_svg__st5"
            d="M143.7 200.6c-1.4-2-1.8-4.4-1.2-6.8-1.2.5-2.4.9-3.7 1.2v1c0 2.2.6 4.4 1.9 6.3 1.1-.5 2-1.1 3-1.7z"
        />
        <path
            className="organizer-illustration_svg__st5"
            d="M147 198.3c-1.2-1.7-.9-4.1.9-5.3 1.2-.9 2.7-1 4-.3.6-1 1.1-2 1.6-3-.6-.4-1.4-.6-2.1-.7-2.4 2-5.2 3.5-8.1 4.6-.8 2.2-.5 4.7 1 6.7.9-.6 1.8-1.3 2.7-2z"
        />
        <path
            className="organizer-illustration_svg__st5"
            d="M146.9 196c0 .6.2 1.3.6 1.8 1.6-1.3 2.9-2.9 4.1-4.6-.5-.2-1-.4-1.5-.4-1.8.1-3.2 1.6-3.2 3.2zM154.9 185.2c.1-.4.1-.8.2-1.1-.1.4-.3.7-.5 1.1h.3zM153.7 189.1c.4-1.1.8-2.1 1.1-3.3l-.5-.2c-.6 1.1-1.5 2-2.4 2.8.7.2 1.3.4 1.8.7z"
        />
        <path
            className="organizer-illustration_svg__st6"
            d="M99.6 192.7c25 15 52.4-3.9 52.4-3.9l38.8 46.6 6.9-4.1s-21-43.6-30.9-61.6c-4.1-7.4-57.3-9.5-78-4.8.5 7.6-1 20.8 10.8 27.8z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M140.8 168l-28.2-4.9c-.5 0-.9-.5-.8-1 0-.5.5-.9 1-.8l36.3-.6h.2l29 5.8"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M125.4 156.6s5.1 4.8 7.1 5.9c1.9 1.1 8.2 2.8 8.2 2.8s1.1-2.3 1-3.1c-.1-1.8-2.7-4.6-4.1-5.8-1.4-1.2-6.7-3.3-6.7-3.3l-9.5-3.5s-4.8 1.3-4.4 5.8c2.9.9 8.4 1.2 8.4 1.2z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M177.7 166.6l-35.4 1.4c-.5 0-.9-.4-1-.9 0-.1 0-.3.1-.4l14.3-33.7c.1-.4.5-.6.9-.5l34.2 1.4c.5 0 .9.5.9 1 0 .1 0 .2-.1.3l-13.1 31c-.1.2-.4.4-.8.4z"
        />
        <path d="M135.7 83.5c-.9 0-1.6-.5-1.9-1.4l.4-.1c.2.6.8 1.1 1.5 1.1v.4z" />
        <path
            className="organizer-illustration_svg__st4"
            d="M80.4 162.2c0 5.4 3.8 10 9.1 11l-.3-3.6c-4.1-1.3-6.3-5.8-5-9.9.6-2 2.1-3.7 4-4.6-.1-1.2-.1-2.4-.2-3.6-4.5 1.6-7.5 5.9-7.6 10.7z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M76.4 162.2c0 7.7 5.8 14.2 13.4 15.2-.1-1.2-.2-2.3-.3-3.5-6.4-1.2-10.7-7.4-9.5-13.8.8-4.2 3.8-7.8 7.9-9.1-.1-1.2-.1-2.3-.2-3.5-6.6 1.7-11.3 7.7-11.3 14.7z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M84.5 162.2c0 3 1.9 5.7 4.7 6.8l-.3-4.2c-1.2-1.3-1.3-3.2-.3-4.7l-.3-4.2c-2.4 1.1-3.8 3.6-3.8 6.3z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M88.8 163.4c0-.7-.1-1.5-.1-2.2-.2.8-.2 1.6.1 2.2zM76.4 94.4c0 6 3.5 11.4 9 13.9-.1-1.4-.2-2.7-.3-4.1-5.4-3.7-6.9-11-3.3-16.5.4-.6.9-1.1 1.4-1.7-.2-1.4-.4-2.7-.6-4-3.9 3.1-6.2 7.6-6.2 12.4z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M85 103.4c-.2-2.1-.3-4-.5-5.9-.4-1-.6-2.1-.6-3.2 0-.5 0-1.1.2-1.6-.2-2.1-.5-4-.7-5.8-4.1 4.6-3.7 11.7.9 15.8.1.3.4.5.7.7zM64.3 162.2c0 15.1 12.3 27.4 27.4 27.4 1.2 0 2.5-.1 3.7-.3-1-1-1.9-2-2.7-3.2h-1.1c-13.2 0-24-10.7-24-24 0-11.6 8.2-21.4 19.5-23.6 0-1.1-.1-2.3-.2-3.4-13 2.3-22.6 13.7-22.6 27.1z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M68.3 162.2c0 12.9 10.5 23.3 23.3 23.3h.7c-.6-1.1-1.2-2.2-1.6-3.4-11-.5-19.5-9.8-19-20.8.4-9 6.9-16.7 15.8-18.6-.1-1.1-.1-2.3-.2-3.4-11 2-19 11.7-19 22.9z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M72.3 162.2c0 10.2 8 18.7 18.2 19.3-.3-1.1-.5-2.3-.7-3.5-8.7-1-15-8.9-14-17.6.7-6.6 5.4-12 11.8-13.6 0-1.2-.1-2.3-.2-3.5-8.7 2-15 9.8-15.1 18.9zM132.6 205.1c-1.4-2.6-2.1-5.4-2.2-8.4-1.1.1-2.2.3-3.4.4.2 3 .9 6 2.2 8.7 1.1-.2 2.3-.4 3.4-.7zM83.4 199.2c1.6 1 3.2 1.8 4.8 2.5 1.1-.1 2.3-.2 3.5-.2 5.7 0 11.3 1.7 16 5 1.9.2 3.9.4 5.8.4-8-7.7-19.4-10.6-30.1-7.7z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M89.4 202.2c5.4 2.1 11.1 3.4 16.8 4.1-4.4-2.7-9.4-4.2-14.6-4.2-.7 0-1.4.1-2.2.1zM136.6 203.9c-1.4-2.4-2.1-5.1-2.2-7.9-1.1.2-2.2.4-3.4.6.1 2.9.9 5.7 2.2 8.3 1.2-.3 2.3-.6 3.4-1z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M140.4 202.4c-1.3-1.9-2-4.2-2-6.5v-.8c-1.1.3-2.3.6-3.4.8 0 2.7.8 5.4 2.1 7.8 1.2-.4 2.2-.9 3.3-1.3zM99.8 192.5c-1.3-.8-2.6-1.6-3.8-2.7-15.3 2.4-29.6-8.1-32-23.4-2.3-15.1 7.9-29.3 23-31.9 0-1.1-.1-2.3-.2-3.4-17.1 2.7-28.8 18.8-26.1 35.9.2 1.4.5 2.8 1 4.2 3.8 5.9 7.4 11.2 10.6 15.6 7.7 6.2 17.9 8.3 27.5 5.7zM52.3 60.9c0 11-9 20-20 20h-.7c-.5 1.1-1.1 2.2-1.5 3.3.7 0 1.5.1 2.2.1 12.9 0 23.3-10.5 23.4-23.4v-1.7c-1.1.4-2.2.9-3.3 1.4-.1.1-.1.2-.1.3z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M56.4 60.9c0 13.2-10.7 24-24 24-.8 0-1.6 0-2.5-.1-.4 1.1-.8 2.1-1.2 3.3 1.2.1 2.4.2 3.6.2 15.1 0 27.4-12.3 27.4-27.4 0-1 0-1.9-.1-2.8-1.1.2-2.2.5-3.3.9 0 .6.1 1.2.1 1.9zM55.7 128.6c0-12.9-10.5-23.3-23.4-23.3-1.2 0-2.3.1-3.5.3l.9 3.3c.9-.1 1.7-.2 2.6-.2 11 0 20 8.9 20 19.9 0 5.8-2.6 11.5-7 15.3.5 1 1.1 2.1 1.6 3.1 5.6-4.6 8.8-11.3 8.8-18.4z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M63.8 128.6c0-17.4-14.1-31.5-31.5-31.4-1.6 0-3.3.1-4.9.4.1 1.1.2 2.2.4 3.4 15.3-2.5 29.7 7.9 32.1 23.2.2 1.5.4 3 .4 4.4 0 8.8-4.1 17-11.1 22.3.5 1 1.1 2 1.7 3 8.2-5.9 12.9-15.3 12.9-25.3z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M59.8 128.6c0-15.1-12.3-27.4-27.4-27.4-1.5 0-2.9.1-4.4.4.2 1.1.5 2.2.7 3.3 1.2-.2 2.4-.3 3.7-.3 13.2 0 24 10.7 24 24 0 7.3-3.3 14.2-9.1 18.8.5 1 1.1 2 1.7 3 6.8-5.2 10.8-13.2 10.8-21.8zM34.1 76.7c-.7 1.1-1.4 2.3-2.1 3.5h.4c10.7 0 19.3-8.6 19.3-19.3-1.2.6-2.4 1.2-3.5 2-1 7.3-6.8 13-14.1 13.8zM118.2 197.3c-6.4-.3-12.7-1.7-17.6-4.3-9.2 2.6-19.2 1.1-27.1-4.4 2.4 3.2 4.6 5.8 6.3 7.7.9.9 1.9 1.7 2.9 2.5 11.3-3.3 23.5-.1 31.7 8.2h5.7c-1-3.2-1.7-6.4-1.9-9.7z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M47.5 63.3c-1.7 1.1-3.4 2.4-4.9 3.7-1.1 1.7-2.5 3.2-4.2 4.2-1.4 1.6-2.6 3.2-3.8 4.8 6.5-.9 11.8-6.1 12.9-12.7zM72.3 94.4c0 8.4 5.4 15.8 13.3 18.4-.1-1.3-.2-2.5-.3-3.7-8.1-3.4-11.8-12.8-8.4-20.9 1.1-2.7 3-5 5.4-6.7-.2-1.2-.5-2.5-.7-3.6-5.7 3.5-9.3 9.7-9.3 16.5zM60.4 60.9c0 15.5-12.6 28-28 28-1.3 0-2.6-.1-3.8-.3-.3 1-.5 2-.8 3v.3C45 94.5 61 82.6 63.6 65.5c.4-2.6.5-5.3.2-7.9-1.1 0-2.3.2-3.4.4-.1.9 0 1.9 0 2.9zM122.3 197.4h-3.4c.1 3.2.8 6.5 2 9.5 1.2 0 2.4-.2 3.6-.3-1.3-3-2-6.1-2.2-9.2zM128.6 206c-1.3-2.7-2.1-5.8-2.2-8.8-1.1.1-2.3.1-3.4.2.2 3.2.9 6.2 2.1 9.1 1.1-.1 2.3-.3 3.5-.5zM51.7 128.6c0-10.7-8.6-19.3-19.3-19.3-.8 0-1.6 0-2.4.1.3 1.1.7 2.2 1.1 3.3h1.3c8.8 0 15.9 7.1 15.9 15.9 0 4.3-1.8 8.5-4.9 11.5.5 1.1 1.1 2.1 1.6 3.1 4.2-3.6 6.7-8.9 6.7-14.6z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M60.2 94.4c0 15.3 11.1 28.5 26.2 31 0-1.2-.1-2.3-.2-3.5-15.2-3-25.1-17.7-22.1-32.9 1.7-8.5 7.2-15.8 15-19.7-.4-1.1-.9-2.1-1.4-3.1a31.45 31.45 0 0 0-17.5 28.2z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M68.3 94.4c0 10.7 7.3 20 17.6 22.7-.1-1.2-.1-2.4-.2-3.6-10.5-3.3-16.4-14.5-13.1-25 1.5-4.7 4.7-8.7 9-11.3-.3-1.2-.5-2.3-.9-3.4-7.6 4.1-12.4 12-12.4 20.6z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M64.3 94.4c0 13 9.2 24.2 22 26.9-.1-1.2-.1-2.4-.2-3.6-12.9-3.2-20.8-16.1-17.6-29 1.5-6.7 5.9-12.4 12-15.6-.4-1.1-.7-2.2-1.1-3.3-9.3 4.8-15.1 14.2-15.1 24.6zM34.6 121.8c1.3 3.2 2.8 6.3 4.4 9.6.4-.9.6-1.8.5-2.8.1-3.1-2-5.8-4.9-6.8z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M64.4 60.9c0 17.7-14.3 32.1-32 32.1-1.6 0-3.2-.1-4.8-.4-.2 1.4-.3 2.9-.2 4.3 1.6-.3 3.3-.4 4.9-.4 17.7 0 32.1 14.3 32.1 32.1 0 10.2-4.9 19.8-13.1 25.9 3 5.2 6.1 10.3 9.1 15-4-17.2 6.6-34.5 23.9-38.5.8-.2 1.6-.4 2.4-.5-.1-1.5-.2-2.9-.3-4.4C69 123.3 57.1 106.8 60 89.3c1.7-10.2 8.2-19 17.4-23.6-3-5.4-7.2-8.1-13.2-8.1.2 1.1.2 2.2.2 3.3z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M32.8 117.4c.5 1.2 1 2.4 1.5 3.7 3.5.9 5.9 4 5.9 7.6 0 1.2-.3 2.5-.9 3.6.5 1.2 1.1 2.3 1.7 3.5 3.9-4.8 3.2-11.9-1.6-15.8-1.8-1.6-4.1-2.5-6.6-2.6z"
        />
        <path
            className="organizer-illustration_svg__st4"
            d="M32.4 113.3h-1.1c.4 1.1.8 2.2 1.2 3.4 6.6.1 11.8 5.5 11.6 12.1 0 2.7-1.1 5.3-2.8 7.4.5 1.1 1.1 2.1 1.6 3.2 6-5.9 6.1-15.6.2-21.6-2.7-2.8-6.6-4.5-10.7-4.5z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M209.8 243.4c-3.2 0-9-1.6-9.6-1.8l-6.6 1.6-.1-.4 6.7-1.6s6.3 1.8 9.6 1.8c3.4 0 8.4-1.3 8.5-1.4l.1.4s-5 1.4-8.6 1.4zM148.8 266.9h-1.7v-11.3c0-4.5-3.5-8.1-7.8-8.1H90.6c-4.3 0-7.8 3.7-7.8 8.1v11.3h-1.7v-11.3c0-5.4 4.2-9.8 9.5-9.8h48.7c5.3 0 9.5 4.4 9.5 9.8v11.3z"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M140.9 265.1l1.4-7.6.9-5.2 6.5-3 1.7 8.9-2.9 14.2-8.8.6 1.2-7.9z"
        />
        <path d="M151.5 257.7l-3.1 14.5" fill="none" />
        <path
            className="organizer-illustration_svg__st1"
            d="M148.2 272.2l2.8-14.4.5.1-2.9 14.4-.4-.1z"
        />
        <path
            className="organizer-illustration_svg__st3"
            d="M143.3 258.9l4.9-.1v.4l-4.9.1v-.4zM142.9 261.2l4.9-.1v.4l-4.9.1v-.4zM142.4 263.5l4.9-.1v.4l-4.9.1v-.4zM142 265.9l4.9-.1v.4l-4.9.1v-.4zM141.5 268.2l4.9-.1v.4l-4.9.1v-.4z"
        />
        <path
            className="organizer-illustration_svg__st6"
            d="M141.3 255s-3.2-46.4-2.6-67.3c.5-15.8 25.5-19.5 22.6 2.9-3.6 28.1-10.2 64.9-10.2 64.9l-9.8-.5z"
        />
        <path
            d="M162.9 203.4c-.2 0-.3-.1-.4-.2l-10.6-13.7c-.2-.2-.1-.5.1-.7.2-.1.5-.1.7.1l10.6 13.7c.2.2.1.5-.1.7-.1.1-.2.1-.3.1z"
            fill="#f8f7fa"
        />
        <path
            className="organizer-illustration_svg__st2"
            d="M148.5 272.1c-.5 1.8-1.5 4.1-3.1 5.1s-4.5 1-6 .6c-2.1-.5-.5-2.8.4-5.7"
        />
        <path
            className="organizer-illustration_svg__st1"
            d="M141.7 278.2c-.8 0-1.4 0-2.2-.3-.5-.1-.8-.3-1.1-.7-.4-.7 0-1.8.6-3.1.2-.6.5-1.3.8-2.1l.6-.5c-.2.8-.7 2.1-1 2.7-.5 1.2-.9 2.2-.6 2.7.2.3.5.5.8.5 1.5.4 4.1.5 5.6-.5 1.9-1.2 2.9-4.4 3.2-5.3l.2.5c-.3 1.1-1.2 3.8-3.2 5.1-.9.8-2.4 1-3.7 1z"
        />
    </svg>
);

OrganizerIllustrationSvg.displayName = 'OrganizerIllustrationSvg';
export default OrganizerIllustrationSvg;
